import {apiRoot} from "./apiRoot.ts";

export const aboutSlice = apiRoot.injectEndpoints({
    endpoints: build => ({
        getMe: build.query<{
            username: string,
            tenant: string,
        }, void>({
            query: () => `/api/worktimeexpense/about/me`
        })
    })
})


export const {useGetMeQuery} = aboutSlice